import { Injectable } from '@angular/core';

@Injectable()
export class CnaeSupplier {

    allCnaes = [
        {
            cnae: "14.02",
            service: 'SERC0008',
            description: 'Reparação e Manutenção de computadores'
        },
        {
            cnae: "2684",
            service: 'SERC0009',
            description: 'Processamento'
        },
        {
            cnae: "2919",
            service: 'SERC0010',
            description: 'Suporte'
        },
        {
            cnae: "2692",
            service: 'SERC0011',
            description: 'Elaboração e desenvolvimento'
        },
        {
            cnae: "2881",
            service: 'SERC0012',
            description: 'Acessoria e consultoria em info'
        },
        {
            cnae: "2935",
            service: 'SERC0013',
            description: 'Planejamento, confecçãoe manutenção de páginas'
        },
        {
            cnae: "3476",
            service: 'SERC0014',
            description: 'Contabilidade'
        },
        {
            cnae: "7498",
            service: 'SERC0015',
            description: 'Conserto, restauração, manutenção e equipamentos'
        },
        {
            cnae: "2660",
            service: 'SERC0016',
            description: 'Analise e Desenvolvimento de Sistemas'
        },
        {
            cnae: "2668",
            service: 'SERC0017',
            description: 'Programação'
        },
        {
            cnae: "2496",
            service: 'SERC0018',
            description: 'Propaganda e publicidade'
        },
        {
            cnae: "5762",
            service: 'SERC0019',
            description: 'Serviço de instrução e treinamento'
        },
        {
            cnae: "3093",
            service: "SERC0020",
            description: 'Analises, Exames, Pesquisas, compilação coleta de dados'
        },
        {
            cnae: "3115",
            service: 'SERC0021',
            description: 'Assessoria e Consultoria em Info'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/CnaeSupplier.ts